import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Spinner,
} from '@chakra-ui/react';
import KeyboardArrowDownSharpIcon from '@gamma/ui/icons/KeyboardArrowDownSharpIcon';
import { i18n } from '../../../../../../shared/localization';

export interface IAlertTableHeaderStatusMenuProps {
  loading: boolean;
  alertStatusUpdate: (status: boolean) => void;
}

export const AlertTableHeaderStatusMenu = ({
  loading,
  alertStatusUpdate,
}: IAlertTableHeaderStatusMenuProps) => {
  return (
    <Menu>
      <MenuButton
        color="gray.50"
        borderColor="gray.50"
        _active={{
          color: 'gray.50',
          borderColor: 'gray.50',
        }}
        _hover={{
          color: 'gray.50',
          borderColor: 'gray.50',
        }}
        data-testid="bulk-exclude-menu-button"
        disabled={loading}
        as={Button}
        rightIcon={
          loading ? (
            <Spinner data-testid="bulk-exclude-loader" size={'xs'} />
          ) : (
            <KeyboardArrowDownSharpIcon data-testid="alert-catalog-table-header-status-menu-list-chevron" />
          )
        }
      >
        {i18n.pages.system.alertCatalog.status}
      </MenuButton>
      <Portal>
        <MenuList>
          <MenuItem
            data-testid="alert-catalog-table-header-status-menu-list-active-button"
            onClick={() => alertStatusUpdate(true)}
          >
            {i18n.pages.system.alertCatalog.active}
          </MenuItem>
          <MenuItem
            data-testid="alert-catalog-table-header-status-menu-list-inactive-button"
            onClick={() => alertStatusUpdate(false)}
          >
            {i18n.pages.system.alertCatalog.inactive}
          </MenuItem>
        </MenuList>
      </Portal>
    </Menu>
  );
};
